import React from 'react';

const jsonUtils = {
    /**
     * Recursively formats and renders a JSON value, handling objects, arrays, and primitives
     * @param {*} value - The value to render
     * @param {number} depth - Current depth for indentation (0 = no extra padding)
     * @returns {JSX.Element} - Rendered value
     */
    formatJsonObject(value, depth = 0) {
        if (value === null || value === undefined) {
            return <span>{String(value)}</span>;
        }

        const paddingStyle = depth > 0 ? { paddingLeft: `${depth * 20}px` } : {};

        if (Array.isArray(value)) {
            if (value.length === 0) {
                return <span>[]</span>;
            }
            return (
                <div>
                    {value.map((item, index) => (
                        <div key={index} style={paddingStyle}>
                            <strong>[{index}]:</strong> {jsonUtils.formatJsonObject(item, depth + 1)}
                        </div>
                    ))}
                </div>
            );
        }

        if (typeof value === 'object') {
            return (
                <div>
                    {Object.entries(value).map(([key, val]) => (
                        <div key={key} style={paddingStyle}>
                            <strong>{key}:</strong> {jsonUtils.formatJsonObject(val, depth + 1)}
                        </div>
                    ))}
                </div>
            );
        }

        return <span>{String(value)}</span>;
    }
};

export default jsonUtils;

